import BaggageCounter from './components/BaggageCounter.css';

export default {
	BaggageCounter
};
